import * as React from 'react';
import {useCallback, useEffect, useState} from 'react';
import {Title, TopToolbar, useNotify} from 'react-admin';
import {Box, Divider, Grid, Typography} from '@mui/material';

import {fetchList, removeFromList} from './api/api';
import type {SuggestItemDto, SuggestListWineDto} from '../../types/wine';
import {WineCard} from "./WineCard";
import {WineAutocomplete} from "./WineAutocomplete";


export default function WineSuggestionsPage() {
  const notify = useNotify();

  const [list, setList] = useState<SuggestItemDto[]>([]);

  const loadList = useCallback(async () => {
    try {
      const res: SuggestListWineDto = await fetchList();
      setList(res.data ?? []);
    } catch (e: any) {
      notify(e?.message || 'Failed to load suggestion list', { type: 'warning' });
    }
  }, [notify]);

  useEffect(() => {
    void loadList();
  }, [loadList]);

  const handleRemove = async (suggest: SuggestItemDto) => {
    try {
      await removeFromList(suggest.id); // remove by SuggestItem id
      notify(`Removed: ${suggest.wine.name}`, { type: 'info' });
      await loadList();
    } catch (e: any) {
      notify(e?.message || 'Failed to remove', { type: 'error' });
    }
  };

  return (
    <Box p={2}>
      <Title title="Wine Suggestions" />
      <TopToolbar>
        <WineAutocomplete onAdded={() => loadList()} />
        <Box flex={1} />
      </TopToolbar>

      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="h6" gutterBottom>
            Current List ({list.length})
          </Typography>
          {list.length === 0 ? (
            <Typography color="text.secondary">No wines in the list yet.</Typography>
          ) : (
            <Grid container spacing={2} >
              {list.map((s) => (
                <Grid key={s.id} size={{xs: 12, md: 6, lg: 3}}>
                  <WineCard w={s.wine} onRemove={() => void handleRemove(s)} />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
